// Single source of truth for services (used by the Home page and structured data).
// `tagline` is the single line on the front of each card; `description` is the back.
export const services = [
  {
    number: "01",
    title: "Fractional CTO",
    tagline: "Senior tech leadership, on demand.",
    description:
      "Senior technical leadership without the full-time cost. Architecture, roadmap, hiring and investor-ready technology strategy for your startup.",
  },
  {
    number: "02",
    title: "AI Agents & Chatbots",
    tagline: "AI agents that never clock off.",
    description:
      "Autonomous agents built on GPT-5 and Claude that qualify leads, support customers and execute real business workflows — around the clock.",
  },
  {
    number: "03",
    title: "Workflow Automation",
    tagline: "Your tools, working as one.",
    description:
      "n8n and Make pipelines that connect your CRM, apps and marketing into one system, removing hours of manual work every week.",
  },
  {
    number: "04",
    title: "Mobile App Development",
    tagline: "iOS and Android apps, idea to store.",
    description:
      "React Native apps for iOS and Android, from UX to App Store and Google Play launch — 19 live in stores today.",
  },
  {
    number: "05",
    title: "Web & SaaS Platforms",
    tagline: "Fast, scalable web products.",
    description:
      "Next.js, NestJS and Supabase products engineered for speed, scale and a clean handover to your team.",
  },
  {
    number: "06",
    title: "AI Integration & RAG",
    tagline: "GPT-5 and Claude in your product.",
    description:
      "Add GPT-5 or Claude to your existing product, or turn internal documents into a searchable, actionable knowledge base.",
  },
];

// The three pillars shown in "What I do" (tags come from resume skill groups)
export const pillars = [
  {
    title: "AI Products",
    description:
      "Autonomous agents, chatbots and RAG systems built on GPT-5 and Claude — added to your existing product or shipped as a new one, and wired into the workflows your business actually runs on.",
    skillGroup: "AI & LLM Engineering",
  },
  {
    title: "Automation",
    description:
      "n8n and Make pipelines that connect your CRM, WhatsApp, apps and marketing into one system, so agents handle the repetition and your team handles the creativity.",
    skillGroup: "Automation & No-Code",
  },
  {
    title: "Build & Lead",
    description:
      "Fractional CTO leadership plus hands-on delivery: architecture, roadmap and hiring, then React Native apps and Next.js SaaS platforms taken from MVP to App Store and Google Play launch.",
    skillGroup: "Full-Stack Product",
  },
];
